import { render, staticRenderFns } from "./createJobTypeDialog.vue?vue&type=template&id=2654f4a4"
import script from "./createJobTypeDialog.vue?vue&type=script&lang=ts"
export * from "./createJobTypeDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports